<div class="loading-container padding-large">
  <mat-spinner mode="indeterminate" class="center-margin"></mat-spinner>
</div>
